import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'

import InfiniteScroll from '../infinite-scroll/InfiniteScroll'
import Placeholder from '../common/Placeholder'
import CoachActions from './CoachActions'

import AvatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'
import classes from './CoachesTable.module.scss'

const STATUS_LABELS = {
  active: 'Active Member',
  invited: 'Pending Invitation',
  inactive: 'Inactive',
}

const STATUS_CLASSES = {
  invited: classes.statusInvited,
  inactive: classes.statusInactive,
}

const CoachesTable = ({
  coachList,
  hasMore,
  onFetchMore,
}) => {
  if (coachList.length === 0) {
    return (
      <div className='col-6 mx-auto'>
        <Placeholder
          title={'No Coaches Found'}
          icon={'fa-user'}
          subtext1={'Use the search bar to find coaches or add a new coach'}
        />
      </div>
    )
  }

  return (
    <div className={classes.coachesTableContainer}>
      <InfiniteScroll
        dataLength={coachList.length}
        next={onFetchMore}
        hasMore={hasMore}
        scrollableTarget='tableContent'
        className={classes.tableContent}
      >
        <div id='tableContent' className={classes.coachesTable}>
          <table className={classNames('table table-borderless w-100 mb-0')}>
            <thead className={classes.tableHeader}>
              <tr className={classes.coachesTableHeader}>
                <th>Coach</th>
                <th>Email</th>
                <th>Community</th>
                <th>Phone Number</th>
                <th>Date Created</th>
                <th>Last Sign In</th>
                <th>Observations</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {coachList.map((coach) => (
                <tr key={coach.id} className={classNames(classes.coachRow)}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <img
                        src={coach.avatar?.file_url || AvatarPlaceholder}
                        alt={`${coach.first_name} ${coach.last_name}`}
                        className={classes.coachAvatar}
                      />
                      <span className='font-weight-bold ml-2'>{coach.first_name} {coach.last_name}</span>
                    </div>
                  </td>
                  <td>{coach.email}</td>
                  <td>
                    <Link to={`/communities/${coach.communities[0].id}`} target='_blank' rel='noopener noreferrer'>
                      {coach.communities[0].name}
                    </Link>
                  </td>
                  <td>{coach.phone ? `${coach.phone_prefix ?? ''}${coach.phone}` : 'N/A'}</td>
                  <td>{coach.created_at ? moment(coach.created_at).format('MMM D, YYYY') : 'N/A'}</td>
                  <td>{coach.last_sign_in_at ? moment(coach.last_sign_in_at).format('MMM D, YYYY') : 'Never'}</td>
                  <td>
                    <span className={classNames(classes.coachStatus, STATUS_CLASSES[coach.status])}>
                      {STATUS_LABELS[coach.status] || STATUS_LABELS.active}
                    </span>
                  </td>
                  <td className={`${classes.coachCell} ${classes.coachActionsCell}`}>
                    <CoachActions coach={coach} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </InfiniteScroll>
    </div>
  )
}

CoachesTable.propTypes = {
  coachList: PropTypes.arrayOf(PropTypes.object).isRequired,
  hasMore: PropTypes.bool.isRequired,
  onFetchMore: PropTypes.func.isRequired,
}

export default CoachesTable
